import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { handleError, handleSuccess } from '../utils';
import { ToastContainer } from 'react-toastify';
import './Sidebar.css';

function Sidebar() {
  const [loggedInUser, setLoggedInUser] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    setLoggedInUser(localStorage.getItem('loggedInUser'));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('loggedInUser');
    handleSuccess('User Logged out');
    setTimeout(() => {
      window.location.reload(); // Reload the page
      navigate('/login'); // Navigate to the login page
    }, 1000);
  };

  return (
    <div>
      <div className="admin__sidebar">
        <div className="admin__brand">
          <img
            className="admin__logo"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSj3aGhHnXM2zmul3dBNpB5SYSsLvD0d35c0w&s"
            alt="Logo"
          />
          <span className="admin__brand-name">
            <Link className="link" to="/home">
            </Link>
          </span>
        </div>

        <ul className="admin__menu">
          {/* Zoho Connect */}
       

          {/* Questions */}
          <li className="admin__menu-item">
            <Link className="admin__menu-link" to="/event">
              <i className="fas fa-question-circle admin__menu-icon"></i>
              <span className="admin__menu-text">Questions</span>
            </Link>
          </li>
<li className="admin__menu-item">
            <Link className="admin__menu-link" to="/program-templates">
              <i className="fas fa-layer-group admin__menu-icon"></i>
              <span className="admin__menu-text">Program Templates</span>
            </Link>
          </li>
          {/* Programs */}
          <li className="admin__menu-item">
            <Link className="admin__menu-link" to="/programs">
              <i className="fas fa-cubes admin__menu-icon"></i>
              <span className="admin__menu-text">Programs</span>
            </Link>
          </li>

          {/* Languages - NEW */}
          <li className="admin__menu-item">
            <Link className="admin__menu-link" to="/languages">
              <i className="fas fa-globe admin__menu-icon"></i>
              <span className="admin__menu-text">Languages</span>
            </Link>
          </li>
        </ul>

        <div className="admin__logout" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt admin__logout-icon"></i>
          <span className="admin__logout-text">Logout</span>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
